/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 8/29/13
 * Time: 12:38 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require('backbone');
    var DropdownItemsCollection = require('ui/dropdown/js/collections/DropdownItemsCollection');

    var DropdownModel = Backbone.Model.extend({
        defaults : {
            name:"value",
            selectedOption:null,
            activeOption:null,
            items: new DropdownItemsCollection(),
            enabled:true
        },
        hasSelectedOption: function() {
            return !_.isNull(this.get("selectedOption"));
        },
        hasActiveOption: function() {
            return !_.isNull(this.get("activeOption"));
        }
    });

    return DropdownModel;
});
